import Vue from 'vue';
const VueEventBus = new Vue();

export default VueEventBus;